<template>
  <div class="mt-3">
    <b-carousel
      id="carousel-1"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333;"
      class="rounded"
    >
      <!-- Slides with image only -->
      <!--
      <b-carousel-slide img-src="img/banner/Banner1.png">
        <template slot="img">
          <div onclick="window.open('https://www.bajalibros.com/AR/la-crujia-ebooks');" style="cursor:pointer;">
            <img src="img/banner/Banner1.png" width="1024" height="480" class="img-fluid w-100 d-block" />
          </div>
        </template>
      </b-carousel-slide>

      <b-carousel-slide img-src="img/banner/Banner2.png">
        <template slot="img">
          <div @click="$router.push({ path: `/detalles/53` })" style="cursor:pointer;">
            <img src="img/banner/Banner2.png" width="1024" height="480" class="img-fluid w-100 d-block" />
          </div>
        </template>
      </b-carousel-slide>

      <b-carousel-slide img-src="img/banner/Banner3.png">
        <template slot="img">
          <div @click="$router.push({ path: `/detalles/285` })" style="cursor:pointer;">
            <img src="img/banner/Banner3.png" width="1024" height="480" class="img-fluid w-100 d-block" />
          </div>
        </template>
      </b-carousel-slide>

      <b-carousel-slide img-src="img/banner/Banner4.png">
        <template slot="img">
          <div @click="$router.push({ path: `/detalles/51` })" style="cursor:pointer;">
            <img src="img/banner/Banner4.png" width="1024" height="480" class="img-fluid w-100 d-block" />
          </div>
        </template>
      </b-carousel-slide>

      <b-carousel-slide img-src="img/banner/Banner5.png">
        <template slot="img">
          <div @click="$router.push({ path: `/detalles/283` })" style="cursor:pointer;">
            <img src="img/banner/Banner5.png" width="1024" height="480" class="img-fluid w-100 d-block" />
          </div>
        </template>
      </b-carousel-slide>
      -->
      <b-carousel-slide
        v-for="banner in bannerList"
        :key="banner.id"
        :img-src="$store.state.user.siteData.location +
              'repository/banners/' +
              banner.id"
      >
        <template slot="img" v-if="banner.link !== null">
          <div v-if="banner.link[0] === '/'"  @click="$router.push({ path: banner.link })" style="cursor:pointer;">
            <img
              :src="$store.state.user.siteData.location +
              'repository/banners/' +
              banner.id"
              width="1024"
              height="480"
              class="img-fluid w-100 d-block"
            />
          </div>
          <div v-else :onclick="'window.open(\''+banner.link+'\');'" style="cursor:pointer;">
            <img
              :src="$store.state.user.siteData.location +
              'repository/banners/' +
              banner.id"
              width="1024"
              height="480"
              class="img-fluid w-100 d-block"
            />
          </div>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      bannerList: []
    };
  },
  mounted() {
    this.updateBannerList()
  },
  methods: {
    async updateBannerList() {
      console.log(this.$store.state.user.siteData);

      this.bannerList = await axios
        .post(
          this.$store.state.user.siteData.location + "banners/banners/getForStore",
          null,
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          return evtResponse.data.records;
        });
    }
  }
}
</script>